import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b009530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editor-canvas__inner" }
const _hoisted_2 = { class: "editor-canvas__tools" }
const _hoisted_3 = { class: "editor-canvas__tools__item" }
const _hoisted_4 = {
  key: 0,
  class: "editor-canvas__controllers"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "editor-canvas__controllers"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "editor-canvas__tools__item" }
const _hoisted_9 = { class: "editor-canvas__zoom" }
const _hoisted_10 = { class: "editor-canvas__image__container" }
const _hoisted_11 = { class: "editor-canvas__bottom" }
const _hoisted_12 = {
  key: 2,
  class: "editor-finetune"
}
const _hoisted_13 = { class: "editor__settings" }
const _hoisted_14 = { class: "editor__workarea" }

import { onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';

import { useCommonStore } from '@/store/common';
import { useEditorStore } from '@/store/editor';
import { useServicesStore } from '@/store/services';

import { TMode } from '@/types/TMode';

import AddImage from '@/components/common/AddImage/AddImage.vue';
import ImageFinetune from '@/components/common/ImageFinetune/ImageFinetune.vue';
import ProductSettings from '@/components/pages/Generate/ProductSettings/ProductSettings.vue';
import ProductWorkarea from '@/components/pages/Generate/ProductWorkarea/ProductWorkarea.vue';
import ProductToolsBottom from '@/components/pages/Generate/ProductToolsBottom/ProductToolsBottom.vue';
import ResultImage from '@/components/common/ResultImage/ResultImage.vue';

import AiButton from '@/components/UI/AiButton/AiButton.vue';
import AiCanvas from '@/components/UI/AiCanvas/AiCanvas.vue';
import AiCard from '@/components/UI/AiCard/AiCard.vue';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
// import AiDropLoader from '@/components/UI/AiDropLoader/AiDropLoader.vue';
// import AiFileUpload from '@/components/UI/AiFileUpload/AiFileUpload.vue';
import AiTooltip from '@/components/UI/AiTooltip/AiTooltip.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Generate',
  setup(__props) {

const { fetchThemes } = useEditorStore();
const { imageForActions, imageResult, sourceBgImage } = storeToRefs(useServicesStore());
const { generateImageData, themesList } = storeToRefs(useEditorStore());

const { isMobile } = storeToRefs(useCommonStore());

const key = ref<number>(0);
const step = ref<number>(0);
const mode = ref<TMode>('erase');
const brushSize = ref<number>(110);
const aiCanvasRef = ref<any>(null);
const activeZoom = ref<number>(1);
const imageWidth = ref<number>(1);
const imageHeight = ref<number>(1);

const keyUpdateHandler = (): void => {
  key.value += 1;
};

const zoomInHandler = (): void => {
  activeZoom.value += 0.1;
};

const zoomOutHandler = (): void => {
  activeZoom.value -= 0.1;
};

const activeZoomSetHandler = (newVal: number): void => {
  activeZoom.value = newVal;
};

const setMode = (modeVal: TMode): void => {
  mode.value = modeVal;
};

const goToCanvasHandler = (): void => {
  step.value = 1;
};

const goToFinetuneHandler = async (): Promise<void> => {
  const canvasImage = await aiCanvasRef.value.getBackground();
  imageForActions.value = canvasImage.enlargedBase64src;
  step.value = 2;
};

const saveProductHandler = async (): Promise<void> => {
  const canvasImage = await aiCanvasRef.value.getBackground();
  imageForActions.value = canvasImage.enlargedBase64src;
  step.value = 3;
  // sourceBgImage.value = '';
  // // const trimmedImage = await trimTransparent(removeBase64Prefix(canvasImage.enlargedBase64src));
  // const productId = await createProduct(canvasImage);
  // if (productId) {
  //   router.push({ name: 'Editor', params: { id: productId } });
  // }
};

const savePinturaProductHandler = async (image: string): Promise<void> => {
  // const trimmedImage = await trimTransparent(removeBase64Prefix(image));
  imageForActions.value = image;
  step.value = 1;
};

const resetHandler = (): void => {
  step.value = 0;
  imageForActions.value = '';
  imageResult.value = '';
};

onMounted(() => {
  fetchThemes().then((resp) => {
    themesList.value = resp;
  });
  // fetchStyleList().then((resp) => {
  // stylesList.value = resp;
  // });
});

watch(
  () => generateImageData.value.canvas,
  () => {
    if (isMobile.value) {
      const appElem = document.querySelector('.app-template');
      if (appElem) {
        appElem.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    }
  },
  { deep: true },
);

watch(imageForActions, (newVal, oldVal) => {
  if (newVal !== '' && oldVal === '') {
    step.value = 1;
  }
});

watch(step, (newVal) => {
  if (newVal === 1) {
    const img = new Image();
    img.onload = () => {
      imageWidth.value = img.width;
      imageHeight.value = img.height;
    };
    img.src = imageForActions.value;
    const canvas = document.createElement('canvas');
    const img1 = new Image();
    img1.onload = async () => {
      const imageWidth1 = img1.width;
      const imageHeight1 = img1.height;
      if (imageWidth1 / imageHeight1 > 1) {
        canvas.width = 512;
        canvas.height = (512 * imageHeight1) / imageWidth1;
      } else {
        canvas.height = 512;
        canvas.width = (512 * imageWidth1) / imageHeight1;
      }

      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(img1, 0, 0, canvas.width, canvas.height);
        sourceBgImage.value = canvas.toDataURL('image/png');
        key.value += 1;
      }
    };
    img1.src = sourceBgImage.value;
    key.value += 1;
  } else if (newVal === 0) {
    imageForActions.value = '';
    imageResult.value = '';
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(imageForActions) === '' && _unref(imageResult) === '')
      ? (_openBlock(), _createBlock(AddImage, {
          key: 0,
          "is-remove-bg": ""
        }))
      : (_unref(imageForActions) !== '' && step.value === 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["editor-canvas", { 'editor-canvas--mobile': _unref(isMobile) }])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(AiCard, {
                radius: 16,
                class: "editor-canvas__tools__panel"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.brush-type')), 1),
                      (!_unref(isMobile))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(AiTooltip, {
                              "content-class": "editor-canvas__tooltip",
                              top: "",
                              location: "top"
                            }, {
                              top: _withCtx(() => [
                                _createVNode(AiClearButton, {
                                  class: _normalizeClass([{ 'editor-canvas__controller--active': mode.value === 'erase' }, "editor-canvas__controller"]),
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (setMode('erase')))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: require('@/assets/icons/editor/removeBg.svg'),
                                      alt: "#"
                                    }, null, 8, _hoisted_5)
                                  ]),
                                  _: 1
                                }, 8, ["class"])
                              ]),
                              content: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('image-editor.erase')), 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('image-editor.erase-tooltip-text')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(AiTooltip, {
                              "content-class": "editor-canvas__tooltip",
                              top: "",
                              location: "top"
                            }, {
                              top: _withCtx(() => [
                                _createVNode(AiClearButton, {
                                  class: _normalizeClass([{ 'editor-canvas__controller--active': mode.value === 'restore' }, "editor-canvas__controller"]),
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (setMode('restore')))
                                }, null, 8, ["class"])
                              ]),
                              content: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('image-editor.restore-brush')), 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('image-editor.restore-tooltip-text')), 1)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(isMobile))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(AiClearButton, {
                              class: _normalizeClass([{ 'editor-canvas__controller--active': mode.value === 'erase' }, "editor-canvas__controller"]),
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (setMode('erase')))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: require('@/assets/icons/editor/removeBg.svg'),
                                  alt: "#"
                                }, null, 8, _hoisted_7)
                              ]),
                              _: 1
                            }, 8, ["class"]),
                            _createVNode(AiClearButton, {
                              class: _normalizeClass([{ 'editor-canvas__controller--active': mode.value === 'restore' }, "editor-canvas__controller"]),
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (setMode('restore')))
                            }, null, 8, ["class"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_v_spacer),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.size')), 1),
                      _createVNode(_component_v_slider, {
                        min: 0,
                        max: 220,
                        modelValue: brushSize.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((brushSize).value = $event)),
                        modelModifiers: { number: true },
                        style: {"width":"100px"}
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(AiCard, {
                radius: 16,
                class: "editor-canvas__image"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(AiClearButton, {
                      class: "editor-canvas__zoom__button",
                      "active-zoom": activeZoom.value,
                      onClick: zoomOutHandler
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_inline_svg, {
                          src: require('@/assets/icons/IconDecrease.svg')
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    }, 8, ["active-zoom"]),
                    _createVNode(AiClearButton, {
                      class: "editor-canvas__zoom__button",
                      onClick: zoomInHandler
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_inline_svg, {
                          src: require('@/assets/icons/IconIncrease.svg')
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(), _createBlock(AiCanvas, {
                      images: [],
                      width: imageWidth.value,
                      height: imageHeight.value,
                      background: _unref(imageForActions),
                      "restore-background": _unref(sourceBgImage),
                      mode: mode.value,
                      key: key.value,
                      ref_key: "aiCanvasRef",
                      ref: aiCanvasRef,
                      "brush-size": brushSize.value,
                      "active-zoom": activeZoom.value,
                      onActiveZoomSet: activeZoomSetHandler
                    }, null, 8, ["width", "height", "background", "restore-background", "mode", "brush-size", "active-zoom"]))
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_v_spacer),
              _createVNode(AiButton, {
                theme: "dark",
                onClick: resetHandler
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('services.reset')), 1)
                ]),
                _: 1
              }),
              _createVNode(AiButton, {
                theme: "gradient",
                onClick: goToFinetuneHandler
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.correction')), 1)
                ]),
                _: 1
              }),
              _createVNode(AiButton, {
                theme: "gradient",
                onClick: saveProductHandler
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('profile.save')), 1)
                ]),
                _: 1
              })
            ])
          ], 2))
        : _createCommentVNode("", true),
    (_unref(imageForActions) !== '' && step.value === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(ImageFinetune, {
            src: _unref(imageForActions),
            onReset: resetHandler,
            onSave: savePinturaProductHandler,
            onBack: goToCanvasHandler,
            actions: ['reset', 'save', 'back']
          }, null, 8, ["src"])
        ]))
      : (_unref(imageForActions) !== '' && _unref(imageResult) === '' && step.value === 3)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass([{ 'service__container--mobile': _unref(isMobile) }, "service__container editor"])
          }, [
            (_unref(isMobile))
              ? (_openBlock(), _createBlock(ProductWorkarea, { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(), _createBlock(ProductSettings, {
                key: key.value,
                onKeyUpdate: keyUpdateHandler
              }))
            ]),
            _createElementVNode("div", _hoisted_14, [
              (!_unref(isMobile))
                ? (_openBlock(), _createBlock(ProductWorkarea, {
                    key: 0,
                    onKeyUpdate: keyUpdateHandler
                  }))
                : _createCommentVNode("", true),
              _createVNode(ProductToolsBottom, { class: "editor__workarea__tools" })
            ])
          ], 2))
        : (_unref(imageForActions) !== '' && _unref(imageResult) !== '')
          ? (_openBlock(), _createBlock(ResultImage, { key: 4 }))
          : _createCommentVNode("", true)
  ], 64))
}
}

})